module.exports = __webpack_public_path__ + "assets/img/elem5-transperent-bcg.c2dca010.png";